import React, { useState,useContext } from 'react';
import { CreditCard, Mail, User } from 'lucide-react';
import axios from 'axios';
import AppContext from '../../context/AppContext';
import { saveTransactionData } from '../../db/transactions/saveTransactionData';

import { saveTransactionAbonnement } from '../../db/transactions/saveTransactionAbonnement';
import { useNavigate,useLocation } from 'react-router-dom';
const IndexPaiementAbonnement = () => {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [montant, setMontant] = useState(100);
  //const { isSplashVisible, isLoading,id } = useContext(AppContext);
  const { isSplashVisible, isLoading,id,userInfos ,bottom,unProduit} = useContext(AppContext);
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const navigate=useNavigate()

  const idA = searchParams.get('id');
  const keyA = searchParams.get('key');

  const [idAgre, setIdAgre] = useState(idA);

  const [keyAgre, setKeyAgre] = useState(keyA);

  //alert(idA)

const ajouterInvitation = async (paymentId) => {
  try {
    // Utilisation du paymentId directement dans l'URL
    const response = await axios.get(`https://transactions.kappela.xyz/verify-abonnement-fedapay/${paymentId}`);
    console.log('Réponse:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la requête:', error.message);
    throw error;
  }
}

  const generateUniqueId = (ide) => {
    const prefixId=ide.toString(36).substring(6, 10)

    const timestamp = Date.now();
    const randomStr = Math.random().toString(36).substring(2, 10);
    return `${timestamp}${randomStr}`;
};

  const [formData, setFormData] = useState({
    amount: '',
    email: '',
    first_name: '',
    last_name: '',
    idGroup: '',
    idVendeur: '',
    idClient: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);


    if(idAgre=="monero"){
      try {
        const paymentData = {
          amount:unProduit.price,
          currency: "XOF",
          description: `Paiement abonnement`,
          idVendeur:id,
          customer: {
            email: formData.email,
            first_name: "ne",
            last_name: "nel",
          },
          return_url: window.location.origin + "/PaymentStatus",
         // return_url: window.location.origin ,
          metadata: {
            idGroup:"22",
            idVendeur:11,
            idClient:2222,
          },
        };
        
  
        console.log("payements atus est",paymentData)
  
        const response = await axios.post(
          "https://api.moneroo.io/v1/payments/initialize",
          paymentData,
          {
            //pvk_41z3r1|01J9BV23GNVNDKZSRSC5QC68R0
            headers: {
              Authorization:`Bearer ${keyAgre}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );
        console.log("response est ",response)
  
       // console.log(JSON.stringify(response))
     await   saveTransactionAbonnement(response.data.data.id,montant,unProduit.idUser,unProduit.idGroup,unProduit.duration,id,keyAgre)
  // Puis copier le résultat
  
       // console.log("response est ",response.data.customer)
  
        if (response.data.data.checkout_url) {
          window.location.href = response.data.data.checkout_url;
        }
      } catch (error) {
        console.error("Erreur:", error);
        setStatus({ 
          type: 'error', 
          message: error.response?.data?.message || 'Erreur lors de l\'initialisation du paiement'
        });
      } finally {
        setLoading(false);
      }
    }

    else{


      if (window.FedaPay) {

        var unique=generateUniqueId(id)

        await   saveTransactionAbonnement(unique,unProduit.price,unProduit.idUser,unProduit.idGroup,unProduit.duration,id,keyAgre)
        const widget = window.FedaPay.init({
          public_key:keyAgre,
          transaction: {
            amount:unProduit.price,
            description: 'achat',
          },
          customer: {
            lastname: 'Doe',
            firstname: 'hhd',
            mito: '23225',
            email:formData.email
          },
          onComplete:   ({ reason, transaction }) => {
            if (reason === window.FedaPay.CHECKOUT_COMPLETED) {
            //  updatePlanInfoContext(id, 'payant');
            //  navigate("/dashboard")
  
            //  savePaiementAbonnement(idVendeur, idDon,infosDon["price"], idAcheteur);
            


            // alert("succes")

            ajouterInvitation(unique)
  .then(data => {
    console.log('Invitation ajoutée avec succès:', data);
      navigate("/PaymentStatusFedapay");
  })
  .catch(error => {
    console.error('Échec de l\'ajout de l\'invitation:', error);
  });
            } else if (reason === window.FedaPay.DIALOG_DISMISSED) {
              console.log("Le dialogue de paiement a été fermé par l'utilisateur.");

              navigate("/PaymentStatusFedapayFalse");
            }
          },
        });
  
        widget.open();
      } else {
        console.error("FedaPay n'est pas encore chargé.");
      }
    }
   
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-800">Paiement Sécurisé</h2>
          <p className="text-gray-600">Remplissez les informations pour procéder au paiement</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
              <input
                type="email"
                name="email"
                className="pl-10 w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="votre@email.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

         

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white p-3 rounded-md font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? 'Traitement...' : 'Payer Maintenant'}
          </button>
        </form>

        {status && (
          <div className={`mt-4 p-4 rounded-md ${status.type === 'error' ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'}`}>
            {status.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default IndexPaiementAbonnement;